var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChannelLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z",
    fill: "#1E2B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 11.25h-.563V9.562C15.563 7.617 13.945 6 12 6a3.576 3.576 0 0 0-3.563 3.563v1.687h-.562c-.633 0-1.125.516-1.125 1.125v4.5A1.11 1.11 0 0 0 7.875 18h8.25c.61 0 1.125-.492 1.125-1.125v-4.5a1.14 1.14 0 0 0-1.125-1.125zm-2.438 0h-3.374V9.562c0-.914.75-1.687 1.687-1.687.914 0 1.688.773 1.688 1.688v1.687z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.333A8.333 8.333 0 0 1 3.667 12H.333c0 6.443 5.224 11.667 11.667 11.667v-3.334zM20.333 12A8.333 8.333 0 0 1 12 20.333v3.334c6.443 0 11.667-5.224 11.667-11.667h-3.334zM12 3.667A8.333 8.333 0 0 1 20.333 12h3.334C23.667 5.557 18.443.333 12 .333v3.334zm0-3.334C5.557.333.333 5.557.333 12h3.334A8.333 8.333 0 0 1 12 3.667V.333z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelLock);
export default __webpack_public_path__ + "static/media/channel-lock.bb9f735214fe47583dacca7b4bbec812.svg";
export { ForwardRef as ReactComponent };